import { render } from "./AdminMessages.vue?vue&type=template&id=65d4bfd8&scoped=true"
import script from "./AdminMessages.vue?vue&type=script&lang=js"
export * from "./AdminMessages.vue?vue&type=script&lang=js"

import "./AdminMessages.vue?vue&type=style&index=0&id=65d4bfd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d4bfd8"]])

export default __exports__